import Joi from "joi";

export default Joi.object({
	user_id: Joi.string().required(),
	user_key: Joi.string().required()
});
